import React, { useState, useEffect } from "react";
import { Space, message } from "antd";
import { patchProject } from "../Application/Projects.business";
import HtmlEditor from "../../HtmlEditor/HtmlEditor";
import Button from "../../Layout/DesignSystem/Button/Button";
import { getProjects } from "../Application/Projects.business";
import { CustomFormSelect } from "../../Utils/UI/Text";

const ProjectsTranslations = ({ record }) => {
  const [value, setValue] = useState("");
  const [key, setKey] = useState(null);
  const [language, setLanguage] = useState(null);

  const onChangeLanguage = (languageValue) => {
    setLanguage(languageValue);
    setValue(record && key ? record.info[languageValue][key] : "");
  };

  const onChangeKey = (keyValue) => {
    setKey(keyValue);
    setValue(record && language ? record.info[language][keyValue] : "");
  };

  useEffect(() => {
    setValue(value);
  }, [value]);

  const handleUpdate = async () => {
    try {
      const cleanValue = value.replace(/<[^>]+>/g, "");

      await patchProject(record.id, [
        {
          op: "replace",
          path: `/info/${language}/${key}`,
          value: cleanValue,
        },
      ]);
      getProjects();
      message.success("Se actualizó con éxito");
    } catch (error) {
      message.error(" Se produjo un error, vuelve a intentarlo");
    }
  };

  const keys = [
    { key: "name", value: "Nombre" },
    { key: "description", value: "Descripción" },
    { key: "country", value: "País" },
    { key: "objective", value: "Objetivo" },
    { key: "location", value: "Ubicación" },
    { key: "first_title_sensors", value: "Primer título de sensores" },
    {
      key: "first_description_sensors",
      value: "Primera descripción de sensores",
    },
    { key: "second_title_sensors", value: "Segundo título de sensores" },
    {
      key: "second_description_sensors",
      value: "Segunda descripción de sensores",
    },
    { key: "third_title_sensors", value: "Tercer título de sensores" },
    {
      key: "third_description_sensors",
      value: "Tercer descripción de sensores",
    },
    {
      key: "commitment_to_guidelines",
      value: "Compromiso con las directrices",
    },
    { key: "about", value: "Acerca de" },
    { key: "development", value: "Desarrollo" },
    { key: "issuer", value: "Issuer" },
    { key: "vcs_project_status", value: "VCS estado del proyecto" },
    { key: "vcs_project_type", value: "VCS tipo del proyecto" },
    { key: "project_type", value: "Tipo de proyecto" },
  ];
  return (
    <>
      <div className="container-projectsTranslations">
        <CustomFormSelect
          name="key"
          placeholder="Selecciona un campo"
          options={keys.map((item) => ({
            label: item.value,
            value: item.key,
          }))}
          onChange={onChangeKey}
        />

        <CustomFormSelect
          name="language"
          placeholder="Selecciona un idioma"
          options={[
            { label: "Español", value: "es" },
            { label: "Inglés", value: "en" },
          ]}
          onChange={onChangeLanguage}
        />
      </div>

      <Space
        direction="vertical"
        style={{
          width: "100%",
          marginTop: 8,
        }}
      >
        <HtmlEditor value={value} onChange={setValue} />
        <div className="translations-footer">
          <Button
            htmlType="submit"
            onClick={handleUpdate}
            text={"Guardar"}
            block={false}
            type="button-elem translations-save-button"
            disabled={!key || !language || !value?.trim()}
          />
        </div>
      </Space>
    </>
  );
};

export default ProjectsTranslations;
